import React, { useState, useEffect } from "react";
import "./googlead.css";
import TextField from "@material-ui/core/TextField";
import { Button, CircularProgress } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import LinkedInDescriptionInput from "../DescriptionInput/LinkedInDescription";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useDispatch, useSelector } from 'react-redux';
import { genrateGoogleAdd } from '../../../../../actions/generateActions';
import { useLocation } from 'react-router-dom';

function GoogleAd() {
  const dispatch = useDispatch();
  const location = useLocation();

  const googleAdGenerate = useSelector(state => state.googleAdGenerate);
  const { loading, error } = googleAdGenerate;

  const [keywords, setKeywords] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  const [adDesc, setAdDesc] = useState("")

  const handleDelete = (item) => {
    setKeywords(
      keywords.filter((i) => {
        return i !== item;
      })
    );
  };

  const handleGoogleAd = e => {
    e.preventDefault();
    if (companyName && adDesc && websiteURL) {
      dispatch(genrateGoogleAdd(companyName, adDesc, websiteURL));
    } else if (!companyName) {
      setErrorMessage("Enter company name first");
    } else if (!adDesc) {
      setErrorMessage("Enter add description first");
    } else if (!websiteURL) {
      setErrorMessage("Enter website URL first");
    }
  }

  useEffect(() => {
    if (location.state) {
      setAdDesc(location.state.description);
    }
  }, [location.state])

  return (
    <div className="googlead">
      {(error || errorMessage) && <h3> {error || errorMessage}</h3>}
      {" "}
      <TextField
        required
        id="outlined-required"
        label="Company Name"
        value={companyName}
        onChange={e => setCompanyName(e.target.value)}
        variant="outlined"
        margin="dense"
      />
      <TextField
        id="outlined-required"
        value={websiteURL}
        onChange={e => setWebsiteURL(e.target.value)}
        label="Website Address"
        variant="outlined"
        margin="dense"
      />
      <TextField
        required
        margin="dense"
        fullWidth
        id="outlined-required"
        label="Audience"
        variant="outlined"
      />
      <LinkedInDescriptionInput label="Description" descValue={adDesc} changeDesc={setAdDesc} />
      <div className="input__info">
        {" "}
        <TextField
          required
          fullWidth
          margin="dense"
          id="outlined-required"
          label="Tone or Product Keywords"
          variant="outlined"
          value={keywords.join(",")}
          placeholder="Enter keywords comma seperated"
          onChange={(e) => {
            setKeywords(e.target.value.split(","));
          }}
        />
        <InfoOutlinedIcon />
      </div>
      <div className="target__keywords__container">
        {" "}
        {keywords?.map((item, index) => {
          return (
            <Chip
              key={index}
              label={item}
              onDelete={() => handleDelete(item)}
              color="primary"
              variant="outlined"
            />
          );
        })}
      </div>
      <TextField
        id="outlined-required"
        label="Keywords to avoid"
        variant="outlined"
        margin="dense"
      />
      <div className="mainsoftwaresidebar__content__submitbutton">
        {" "}
        {loading ? <CircularProgress /> : (
          <Button
            disableRipple={true}
            disableFocusRipple={true}
            onClick={handleGoogleAd}
            variant="outlined"
            size="small"
            className="hover__backgroundchange__buttons"
          >
            Generate
          </Button>
        )}
        {/* <p style={{ marginTop: "0.5rem" }}>
          <span className="dollar__sign">
            <i className="fas fa-dollar-sign"></i>
          </span>
          <span className="generate__coins__display">15 coins</span>
        </p> */}
      </div>
    </div>
  );
}

export default GoogleAd;
